import { IconType } from "react-icons";
import {
    HiOutlinePlus,
    HiOutlineUserCircle,
    HiOutlineUser,
    HiOutlineXMark,
    HiOutlineArrowUp,
    HiOutlineArrowDown,
    HiOutlineArrowsUpDown,
    HiOutlineInformationCircle,
    HiOutlineCheckCircle,
    HiOutlineBars3,
    HiOutlineArrowLeft,
    HiOutlineArrowUturnLeft,
    HiOutlinePaperAirplane,
    HiOutlinePencilSquare,
    HiOutlineChatBubbleLeft,
    HiOutlineDocumentDuplicate,
    HiOutlineEllipsisHorizontal,
    HiOutlineEllipsisVertical,
    HiOutlineChevronRight,
    HiOutlineChevronDown,
    HiOutlineArrowTopRightOnSquare,
    HiOutlineMapPin,
    HiOutlineCalendar,
    HiOutlineCog6Tooth,
    HiOutlineExclamationTriangle,
    HiOutlineStar,
    HiOutlineTrophy,
    HiOutlineClipboardDocumentList,
    HiOutlineUserGroup,
    HiOutlineChartBar,
    HiOutlineBell
} from "react-icons/hi2";

export enum JcBuiltInIcon {
    PLUS = "plus",
    USER_CIRCLE = "user-circle",
    USER = "user",
    X_MARK = "x-mark",
    ARROW_UP = "arrow-up",
    ARROW_DOWN = "arrow-down",
    ARROWS_UP_DOWN = "arrows-up-down",
    INFORMATION_CIRCLE = "information-circle",
    CHECK_CIRCLE = "check-circle",
    BARS_3 = "bars-3",
    ARROW_LEFT = "arrow-left",
    ARROW_UTURN_LEFT = "arrow-uturn-left",
    PAPER_AIRPLANE = "paper-airplane",
    PENCIL_SQUARE = "pencil-square",
    CHAT_BUBBLE = "chat-bubble",
    DOCUMENT_DUPLICATE = "document-duplicate",
    ELLIPSIS_HORIZONTAL = "ellipsis-horizontal",
    ELLIPSIS_VERTICAL = "ellipsis-vertical",
    CHEVRON_RIGHT = "chevron-right",
    CHEVRON_DOWN = "chevron-down",
    ARROW_TOP_RIGHT_ON_SQUARE = "arrow-top-right-on-square",
    MAP_PIN = "map-pin",
    CALENDAR = "calendar",
    COG = "cog",
    EXCLAMATION_TRIANGLE = "exclamation-triangle",
    STAR = "star",
    TROPHY = "trophy",
    CLIPBOARD = "clipboard",
    USER_GROUP = "user-group",
    CHART_BAR = "chart-bar",
    BELL = "bell",
}

// Full list accessible via https://github.com/tailwindlabs/heroicons
export const JC_BUILT_IN_ICONS: Record<JcBuiltInIcon, IconType> = {
    [JcBuiltInIcon.PLUS]: HiOutlinePlus,
    [JcBuiltInIcon.USER_CIRCLE]: HiOutlineUserCircle,
    [JcBuiltInIcon.USER]: HiOutlineUser,
    [JcBuiltInIcon.X_MARK]: HiOutlineXMark,
    [JcBuiltInIcon.ARROW_UP]: HiOutlineArrowUp,
    [JcBuiltInIcon.ARROW_DOWN]: HiOutlineArrowDown,
    [JcBuiltInIcon.ARROWS_UP_DOWN]: HiOutlineArrowsUpDown,
    [JcBuiltInIcon.INFORMATION_CIRCLE]: HiOutlineInformationCircle,
    [JcBuiltInIcon.CHECK_CIRCLE]: HiOutlineCheckCircle,
    [JcBuiltInIcon.BARS_3]: HiOutlineBars3,
    [JcBuiltInIcon.ARROW_LEFT]: HiOutlineArrowLeft,
    [JcBuiltInIcon.ARROW_UTURN_LEFT]: HiOutlineArrowUturnLeft,
    [JcBuiltInIcon.PAPER_AIRPLANE]: HiOutlinePaperAirplane,
    [JcBuiltInIcon.PENCIL_SQUARE]: HiOutlinePencilSquare,
    [JcBuiltInIcon.CHAT_BUBBLE]: HiOutlineChatBubbleLeft,
    [JcBuiltInIcon.DOCUMENT_DUPLICATE]: HiOutlineDocumentDuplicate,
    [JcBuiltInIcon.ELLIPSIS_HORIZONTAL]: HiOutlineEllipsisHorizontal,
    [JcBuiltInIcon.ELLIPSIS_VERTICAL]: HiOutlineEllipsisVertical,
    [JcBuiltInIcon.CHEVRON_RIGHT]: HiOutlineChevronRight,
    [JcBuiltInIcon.CHEVRON_DOWN]: HiOutlineChevronDown,
    [JcBuiltInIcon.ARROW_TOP_RIGHT_ON_SQUARE]: HiOutlineArrowTopRightOnSquare,
    [JcBuiltInIcon.MAP_PIN]: HiOutlineMapPin,
    [JcBuiltInIcon.CALENDAR]: HiOutlineCalendar,
    [JcBuiltInIcon.COG]: HiOutlineCog6Tooth,
    [JcBuiltInIcon.EXCLAMATION_TRIANGLE]: HiOutlineExclamationTriangle,
    [JcBuiltInIcon.STAR]: HiOutlineStar,
    [JcBuiltInIcon.TROPHY]: HiOutlineTrophy,
    [JcBuiltInIcon.CLIPBOARD]: HiOutlineClipboardDocumentList,
    [JcBuiltInIcon.USER_GROUP]: HiOutlineUserGroup,
    [JcBuiltInIcon.CHART_BAR]: HiOutlineChartBar,
    [JcBuiltInIcon.BELL]: HiOutlineBell,
};

export const isJcBuiltInIcon = (value: unknown): value is JcBuiltInIcon => {
    return typeof value === "string" && (Object.values(JcBuiltInIcon) as string[]).includes(value);
}